import { createUseStyles } from 'react-jss'

import { inventoryTimelineLabelWidth, timelineRowGap } from '../InventoryTimeline/styles'

const useStyles = createUseStyles({
  container: {
    marginTop: '24px',
    marginBottom: '16px',
    position: 'relative',
    width: `calc(100% - ${inventoryTimelineLabelWidth}px - ${timelineRowGap}px)`,
    marginLeft: 'auto',
    padding: '24px 0 12px'
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column'
  }
})

export default useStyles
